$(document).ready(function () {
  $('.signcounter[maxlength]').each(function () {
    var maxLength = parseInt($(this).attr('maxlength'));
    if (maxLength > 0) {
      var countdownBox = $('<div style="font-size:11px; font-family:Verdana, Arial, sans-serif; color:#666;" />');
      $(this).after(countdownBox);
      $(this).keyup(function () {
        var t = maxLength - $(this).val().length;
        countdownBox.html('Zeichen Ã¼brig: ' + t + ' (von max. ' + maxLength + ')');
      });
      $(this).trigger('keyup');
    }
  });
  $('[data-toggle="popover"]').popover({
    sanitize: false,
  });
  $(document).on('click', '[data-toggle="lightbox"]', function (event) {
    event.preventDefault();
    $(this).ekkoLightbox({
      alwaysShowClose: true,
    });
  });
  $('.contentbox').on('click', function () {
    var title = $(this).attr('title');

    var selector = $(this).attr('data-popup-content');
    var content = $(selector).html();

    var dialog = $(
      '<div class="modal fade" id="contentbox" tabindex="-1" role="dialog" aria-labelledby="Contentbox" aria-hidden="true">' +
        '<div class="modal-dialog modal-lg modal-dialog-centered" role="document">' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '<div class="modal-title"><h5>' +
        title +
        '</h5></div>' +
        '<button type="button" class="close" data-dismiss="modal" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' +
        '</div>' +
        '<div class="modal-body main-content"></div>' +
        '<div class="modal-footer">' +
        '<button type="button" class="btn btn-primary custom-btn" data-dismiss="modal">Schließen</button>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>'
    );

    dialog.appendTo('body');
    dialog.modal('show').on('hidden.bs.modal', function () {
      dialog.remove();
    });

    dialog.find('.modal-body').html(content);

    return false;
  });

  $('#mainCarousel').carousel({
    interval: 8000,
  });

  $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function () {
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate(
          {
            scrollTop: target.offset().top - 54,
          },
          1200,
          'easeInOutExpo'
        );
        return false;
      }
    }
  });

  $('span.js-scroll-trigger').click(function () {
    var target = $($(this).attr('data-scroll'));
    if (target.length) {
      $('html, body').animate(
        {
          scrollTop: target.offset().top - 54,
        },
        1200,
        'easeInOutExpo'
      );
      return false;
    }
  });

  $('.js-scroll-trigger').click(function () {
    $('.navbar-collapse').collapse('hide');
  });

  $('.carousel.clazy').on('slide.bs.carousel', function (e) {
    var lazy;
    lazy = $(e.relatedTarget).find('img[data-src]');
    if (lazy.length !== 0) {
      lazy.attr('src', lazy.data('src'));
      lazy.remove('data-src');
    }
  });

  var elements = $('[data-link]');

  elements.on('click', function () {
    var dataBlank = $(this).attr('data-blank');
    var dataUrl = atob($(this).attr('data-link'));

    if (dataBlank && dataUrl) {
      var a = document.createElement('a');
      a.target = '_blank';
      a.rel = 'nofollow noopener';
      a.href = dataUrl;
      a.setAttribute('type', 'hidden');
      document.body.appendChild(a);
      a.click();
      a.remove();
    } else {
      if (dataUrl) {
        location.href = dataUrl;
      }
    }
  });
});
